import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import { GlobalContext } from "../Context/GlobalContext";
import { Link, useLocation } from "react-router-dom";

// ...

const DesktopHeader: React.FC = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [communityPartnerStatus, setCommunityPartnerStatus] = useState(
    "Community Partner Sign In",
  );
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(GlobalContext);

  const authorized = context?.authorized;
  const setAuthorized = context?.setAuthorized ?? (() => {});

  
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);

  const links = [
    { href: "/about", text: "About Us", hasDropdown: true },
    { href: "/browse", text: "Browse Dogs", hasDropdown: false },
    { href: "/get-involved", text: "Get Involved", hasDropdown: false },
    { href: "/donate", text: "Donate", hasDropdown: false },
    { href: "/shop", text: "Shop", hasDropdown: false },
    { href: "/community-partners", text: "Community Partners", hasDropdown: false },
  ];

  const aboutDropdownItems = [
    { href: "/about", text: "Our Team" },
    { href: "/faq", text: "FAQ" },
    { href: "/contact", text: "Contact Us" },
  ];

  const toggleLogoutModal = () => {
    setShowLogoutModal(!showLogoutModal);
  };

  const confirmLogout = () => {
    sessionStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userData");
    setAuthorized(false);
    setShowLogoutModal(false);
    navigate("/");
  };

  const handleCommunityPartnerClick = () => {
    if (communityPartnerStatus === "Sign Out") {
      toggleLogoutModal();
      return;
    }
    if (communityPartnerStatus === "Community Partner Sign In") {
      navigate("/login/");
      return;
    }
    if (communityPartnerStatus === "Back To Home") {
      navigate("/");
      return;
    }
  };

  

  useEffect(() => {
    if (authorized) {
      setCommunityPartnerStatus("Sign Out");
    } else {
      if (
        !location.pathname.startsWith("/register") &&
        !location.pathname.startsWith("/login")
      ) {
        setCommunityPartnerStatus("Community Partner Sign In");
      } else {
        setCommunityPartnerStatus("Back To Home");
      }
    }
  }, [authorized, location.pathname]);

  return (
    <header className="flex h-225 w-full flex-col font-poppins">
      <section
        id="top-container"
        className="flex h-177 w-full items-center justify-center bg-white"
      >
        <div id="left-section" className="h-177 flex-1"></div>
        <div
          id="middle-section"
          className="flex h-177 flex-1 items-center justify-center"
        >
          <button
            id="logo"
            className="flex max-w-363 items-center justify-center"
            onClick={() => navigate("/")}
          >
            <img
              src="/images/png-jpg/pup_profile_header.png"
              alt="Pup Profile Header Logo"
            />
          </button>
        </div>
        <div
          id="right-section"
          className="flex h-177 flex-1 items-center justify-center"
        >
          <div id="left-spacer" className="h-177 flex-1 border-green-500"></div>
          <div
            id="mid-spacer"
            className="flex h-177 w-fit flex-col items-center justify-center gap-2 border-blue-500"
          >
            <div className="flex flex-row items-center gap-2">
              <button
                className="flex items-center justify-center rounded-md bg-yellow px-6 py-2 transition hover:bg-yellow/90"
                onClick={() => {
                  navigate("/donate");
                  window.scrollTo(0, 0);
                }}
              >
                <p className="font-poppins text-sm font-bold text-white">
                  Donate
                </p>
              </button>
              <button
                className="flex items-center justify-center rounded-md bg-blue px-6 py-2 transition hover:bg-blue-dark"
                onClick={() => {
                  navigate("/shop");
                  window.scrollTo(0, 0);
                }}
              >
                <p className="font-poppins text-sm font-bold text-white">
                  Shop
                </p>
              </button>
            </div>
            {authorized && (
              <div className="flex flex-row items-center gap-2">
                <button
                  className="flex items-center justify-center text-nowrap rounded-7.5 border-2 border-cmsigninborder"
                  onClick={() => navigate("/dashboard")}
                >
                  <p className="px-cmsigninpy py-cmsigninpx font-poppins text-cmsigninsize font-normal text-cmsignintext hover:bg-gray-dark hover:text-white">
                    Community Partner Dashboard
                  </p>
                </button>
                <button
                  className="flex items-center justify-center text-nowrap rounded-7.5 border-2 border-cmsigninborder"
                  onClick={handleCommunityPartnerClick}
                >
                  <p className="px-cmsigninpy py-cmsigninpx font-poppins text-cmsigninsize font-normal text-cmsignintext hover:bg-gray-dark hover:text-white">
                    {communityPartnerStatus}
                  </p>
                </button>
              </div>
            )}
          </div>
          <div
            id="right-spacer"
            className="h-177 max-w-100 flex-1 border-red-500"
          ></div>
        </div>
      </section>
      <section
        id="nav-links"
        className="relative flex h-14 w-full items-center justify-center bg-blue"
      >
        <div className="flex max-w-942 flex-1 justify-between px-1.5 font-poppins text-navlinks font-bold text-white">
          {links.map(({ href, text, hasDropdown }) => (
            <div
              key={href}
              className="relative mt-4.5 flex w-fit flex-col"
              onMouseEnter={() => hasDropdown && setShowAboutDropdown(true)}
              onMouseLeave={() => hasDropdown && setShowAboutDropdown(false)}
            >
              <Link
                to={href}
                className="whitespace-nowrap px-ninepx text-navlinksize"
              >
                {text}
              </Link>
              <div
                className={`mt-3 h-0.5 max-w-full transform bg-yellow ${location.pathname.includes(href) || (hasDropdown && (location.pathname.includes('/faq') || location.pathname.includes('/contact'))) ? "scale-100" : "scale-0"} origin-center transition-transform duration-500 ease-in-out`}
              ></div>
              {hasDropdown && showAboutDropdown && (
                <div className="absolute left-0 top-full z-50 flex min-w-[200px] flex-col bg-blue shadow-lg">
                  {aboutDropdownItems.map((item, index) => (
                    <React.Fragment key={item.href}>
                      <Link
                        to={item.href}
                        className="px-4 py-3 text-sm font-semibold text-white transition hover:bg-blue-dark"
                      >
                        {item.text}
                      </Link>
                      {index < aboutDropdownItems.length - 1 && (
                        <div className="h-px w-full bg-white"></div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="flex flex-col items-center space-y-4 rounded-lg bg-white p-4 shadow-lg">
            <p className="text-lg font-semibold">
              Are you sure you want to Sign out?
            </p>
            <div className="flex space-x-4">
              <button
                className="rounded bg-red-500 px-4 py-2 text-white hover:bg-red-700"
                onClick={confirmLogout}
              >
                Yes
              </button>
              <button
                className="rounded bg-gray-500 px-4 py-2 text-white hover:bg-gray-700"
                onClick={toggleLogoutModal}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default DesktopHeader;
